export default () => ({
	images: [],

	init() {
		this.getAllImages().forEach((img) => {
			const imageUrl = img.currentSrc || img.src
			const button = this.getPinterestButtonTemplate()

			button.setAttribute('href', button.getAttribute('href').replace('%s', imageUrl))

			img.parentElement.appendChild(button)
			img.parentElement.classList.add('relative')
		})
	},

	getAllImages() {
		if (this.images.length > 0) {
			return this.images
		}

		this.images = Array.from(this.$root.querySelectorAll('img:not(.no-pinterest-button)'))

		return this.images
	},

	getPinterestButtonTemplate() {
		const template = this.$root.querySelector('#pinterest-image-button')

		return template.content.querySelector('a').cloneNode(true)
	},
})
